import { Path } from '@vimeo/iris/components';
import { Header, Link, Paragraph } from '@vimeo/iris/typography';

import GuideWrapper from 'src/_components/GuideWrapper';
import Meta from 'src/_components/Meta';

export default function VimeoEnterpriseAbout() {
  return (
    <>
      <Meta
        title="Working with Vimeo Enterprise: About Vimeo Enterprise"
        description="Discover special partner documentation about using the Vimeo API with your Vimeo Enterprise account."
      />
      <GuideWrapper
        breadcrumbs={
          <Path>
            <Path.Link href={'/'}>Home</Path.Link>
            <Path.Link href={'/api/guides/start'}>API</Path.Link>
            <Path.Current>Working with Vimeo Enterprise</Path.Current>
          </Path>
        }
        nav={{ page: 'enterprise', subpage: 'enterprise' }}
        showContextualMenu={false}
      >
        <Header>About Vimeo Enterprise</Header>

        <Paragraph size="2">
          <em>Vimeo Enterprise</em> is our one-stop solution for creating, managing, and delivering
          video-based communications for businesses and organizations of any size. Our dedicated{' '}
          <Link variant="minimal" href="https://vimeo.com/enterprise">
            solution
          </Link>{' '}
          page tells you all about it.
        </Paragraph>

        <Paragraph size="2">
          The Vimeo Enterprise plan offers a number of special features that are callable from the
          Vimeo API, so you can integrate them into your own custom applications.
        </Paragraph>

        <Paragraph size="2">Learn more in the following guides:</Paragraph>

        <ul>
          <li>
            <Link variant="minimal" href="/api/enterprise/custom-subdomains">
              Using Your Custom Subdomain with the Vimeo API
            </Link>
          </li>
          <li>
            <Link variant="minimal" href="/api/federated-search">
              Working with Federated Search
            </Link>
          </li>
          <li>
            <Link variant="minimal" href="/api/live">
              Working with Vimeo Live
            </Link>
          </li>
        </ul>

        <Paragraph size="2">
          For complete technical details about the Vimeo API endpoints, see our{' '}
          <Link variant="minimal" href="/api/reference">
            API Reference
          </Link>
          {''}.
        </Paragraph>
      </GuideWrapper>
    </>
  );
}
